import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { CourseScheduleCapabilityConfiguration } from '../../../src/configuration';
import { ScheduleQuery } from './../../queries/schedule_query';
import { CalendarIntegrationService } from './../../services/calendar_integration_service';

interface IScheduleFlags {
  isTermFilterOpen: boolean;
  headerTheme: string;
  hasMultipleTerms: boolean;
  hasLoaded: boolean;
}

export class MyScheduleListViewController {
  private _termId: any;
  private termText: string;
  private flags: IScheduleFlags;

  constructor(
    private ngCourseScheduleCapabilityConfiguration: CourseScheduleCapabilityConfiguration,
    private $state: ng.ui.IStateService,
    private $stateParams: ng.ui.IStateParamsService,
    private ngScheduleQuery: ScheduleQuery,
    private ngCalendarIntegrationService: CalendarIntegrationService,
    courseListCommand: ICommand
  ) {
    this.flags = {
      hasLoaded: false,
      isTermFilterOpen: false,
      headerTheme: this.ngCourseScheduleCapabilityConfiguration.config.navIconTheme,
      hasMultipleTerms: _4.size(this.ngScheduleQuery.getTerms()) > 1
    };

    if (_4.isEmpty(this.ngScheduleQuery.result)) {
      courseListCommand()
        .then(() => {
          this.updateFlagsAfterCommand();
          this.findTermIdOnLoad();
        })
        .catch(() => this.updateFlagsAfterCommand());
    } else {
      this.updateFlagsAfterCommand();
      this.findTermIdOnLoad();
    }
  }

  set termId(term: any) {
    this._termId = parseInt(term, 10);
    this.ngScheduleQuery.setPersistantTerm(this._termId);
    this.refresh();
  }

  get termId() {
    return this._termId;
  }

  findTermIdOnLoad(): void {
    if (_4.isEmpty(this.$stateParams.term)) {
      this.termId = this.ngScheduleQuery.getPersistantTerm();
      if (_4.isNaN(this.termId)) {
        this.termId = _4.get(_.first(this.ngScheduleQuery.getTerms()), 'id');
        this.ngScheduleQuery.setPersistantTerm(this.termId);
      }
    } else {
      this.termId = this.ngScheduleQuery.setPersistantTerm(this.$stateParams.term);
    }
  }

  updateFlagsAfterCommand(): void {
    this.flags.hasLoaded = true;
    this.flags.hasMultipleTerms = _4.size(this.ngScheduleQuery.getTerms()) > 1;
  }

  refresh(): void {
    this.termText = _.isEmpty(this.ngScheduleQuery.getTermText(this.termId))
      ? `My Class Schedule`
      : `Courses: ${this.ngScheduleQuery.getTermText(this.termId)}`;
  }

  toggleTermFilter(): void {
    this.flags.isTermFilterOpen = !this.flags.isTermFilterOpen;
  }

  closeTermFilter(): void {
    this.flags.isTermFilterOpen = false;
  }

  isSelectedTerm(termID: number): boolean {
    return this.termId === termID;
  }

  setSelectedTerm(termID: number): void {
    this.$state.go('my.courseSchedule.term', { term: termID });
    this.closeTermFilter();
    this.termId = termID;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/views/my_schedule_list_view/my_schedule_list_view_controller.ts